import { GET_GLOBAL_NOTES_SUCCESS } from "./note.type";

const initialState = {
  notesList: [],
};

export const noteReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_GLOBAL_NOTES_SUCCESS:
      return {
        ...state,
        notesList: action.payload,
      };

    default:
      return state;
  }
};
